const protocolReg = /^(https?:\/\/|mailto:)/;
const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function normalizeUrl(url: string) {
  return protocolReg.test(url) ? url : emailReg.test(url) ? `mailto:${url}` : `http://${url}`;
}
